

class AccordionGroupHTMLElement extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() { }
}

customElements.define( 'accordion-group', AccordionGroupHTMLElement );